export const defaultViewport = {
    center: [1, 20],
    zoom: 3.25,
};
export const boundariesZoomLimit = 6;
